
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18 1.01L7.99997 1C6.89997 1 5.99997 1.9 5.99997 3V6C5.99997 6.55 6.44997 7 6.99997 7C7.54997 7 7.99997 6.55 7.99997 6V5H18V19H7.99997V18C7.99997 17.45 7.54997 17 6.99997 17C6.44997 17 5.99997 17.45 5.99997 18V21C5.99997 22.1 6.89997 23 7.99997 23H18C19.1 23 20 22.1 20 21V3C20 1.9 19.1 1.01 18 1.01ZM11 15C11.55 15 12 14.55 12 14V9C12 8.45 11.55 8 11 8H5.99997C5.44997 8 4.99997 8.45 4.99997 9C4.99997 9.55 5.44997 10 5.99997 10H8.58997L3.69997 14.89C3.30997 15.28 3.30997 15.91 3.69997 16.3C4.08997 16.69 4.71997 16.69 5.10997 16.3L9.99997 11.41V14C9.99997 14.55 10.45 15 11 15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-add-to-home-screen`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAddToHomeScreen

    ```js
    <b-new-b-icon-add-to-home-screen />
    ```
</docs>


